export default __webpack_public_path__ + "static/media/cms.c4ec12be.svg";